import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="collapsible"
export default class extends Controller {
  static targets = [
    'caret',
    'body'
  ]

  connect() {
    this.isOpen = false;
    if (this.element.getAttribute("data-auto-open") == "true") {
      this.open();
    }
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    if (!this.hasBodyTarget || !this.hasCaretTarget) return;

    this.bodyTarget.classList.remove("h-0");
    this.caretTarget.classList.add("rotate-90");
    this.isOpen = true;
    this.loadDeferredSources();
  }

  close() {
    if (!this.hasBodyTarget || !this.hasCaretTarget) return;

    this.bodyTarget.classList.add("h-0");
    this.caretTarget.classList.remove("rotate-90");
    this.isOpen = false;
  }

  // A collapsed body still loads its iframes: `loading="lazy"` is a hint the browser may ignore. Anything
  // expensive inside a collapsible can carry its URL as data-deferred-src instead and be fetched on first open.
  loadDeferredSources() {
    this.bodyTarget.querySelectorAll("[data-deferred-src]").forEach((element) => {
      element.src = element.dataset.deferredSrc;
      delete element.dataset.deferredSrc;
    });
  }
}
